import { Component, Input, ViewChild } from '@angular/core'
import { ModalContainerComponent } from '../../_common/modal-container/modal-container.component'

@Component({
  selector: 'modal-status',
  templateUrl: 'modal-status.component.html',
})
export class ModalStatusComponent {
  @ViewChild('modal') public childModal: ModalContainerComponent
  @Input() public title: string
  @Input() public body: string
  @Input() public bodyCentered: boolean

  public showChildModal(title?: string, body?: string, bodyCentered?: boolean): void {
    if (title) {
      this.title = title
    }
    if (body) {
      this.body = body
    }
    if (bodyCentered) {
      this.bodyCentered = bodyCentered
    }
    this.childModal.showChildModal()
  }

  public hideChildModal(): void {
    this.childModal.hideChildModal()
  }
}
